"use client";
import { type ReactNode, useEffect } from "react";
import { OspApiClientProvider } from "../api";
import { config } from "@config";
import { initFingerprint } from "@features";
import { AuthOrchestrator } from "../auth";

export const OspClientIniter = ({ children }: { children: ReactNode }) => {
  if (!config.osp.appId) {
    throw new Error("NEXT_PUBLIC_APP_ID is not set");
  }

  useEffect(() => {
    initFingerprint();
  }, []);

  return (
    <AuthOrchestrator>
      <OspApiClientProvider>{children}</OspApiClientProvider>
    </AuthOrchestrator>
  );
};
